import React, { useContext, useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { FiArrowRight, FiEye, FiEyeOff, FiLock, FiUser } from "react-icons/fi";
import { AuthContext } from "./AuthContext";
import siteConfig from "../config/siteConfig";
import "../css/login.scss";

function Login() {
  const { isAuthenticated, login } = useContext(AuthContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const destination = location.state?.from?.pathname || "/orders";

  useEffect(() => {
    document.title = `Account login — ${siteConfig.brandName}`;
  }, []);

  if (isAuthenticated) {
    return <Navigate to={destination} replace />;
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setError("");

    if (login(username.trim(), password)) {
      navigate(destination, { replace: true });
      return;
    }

    setError("The username or password is incorrect.");
  };

  return (
    <main className="login-page">
      <section className="login-panel">
        <div className="login-panel__mark"><FiLock /></div>
        <p className="eyebrow">Private account</p>
        <h1>Welcome back.</h1>
        <p className="login-panel__intro">
          Sign in to securely access orders and ERP customer information.
        </p>

        <form onSubmit={handleSubmit} noValidate>
          <label>
            <span>Username</span>
            <div className="login-field">
              <FiUser />
              <input
                type="text"
                value={username}
                onChange={(event) => {
                  setUsername(event.target.value);
                  setError("");
                }}
                autoComplete="username"
                placeholder="Enter your username"
                required
                autoFocus
              />
            </div>
          </label>

          <label>
            <span>Password</span>
            <div className="login-field">
              <FiLock />
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(event) => {
                  setPassword(event.target.value);
                  setError("");
                }}
                autoComplete="current-password"
                placeholder="Enter your password"
                required
              />
              <button
                type="button"
                aria-label={showPassword ? "Hide password" : "Show password"}
                onClick={() => setShowPassword((visible) => !visible)}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
          </label>

          {error && <p className="login-error" role="alert">{error}</p>}

          <button className="btn login-submit" type="submit">
            Sign in <FiArrowRight />
          </button>
        </form>
      </section>

      <aside
        className="login-aside"
        aria-hidden="true"
        style={{
          backgroundImage:
            'linear-gradient(0deg, rgba(54,18,29,.84), rgba(54,18,29,.18)), url("/img/editorial/collection.jpg")',
        }}
      >
        <div>
          <p className="eyebrow">Account portal</p>
          <blockquote>Orders, delivery progress and customer records—all in one place.</blockquote>
          <span>Private access · Authorised users only</span>
        </div>
      </aside>
    </main>
  );
}

export default Login;
